/*eslint-disable*/

import React from "react";
import { useIntl } from "react-intl";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { HiOutlineBars3, HiOutlineCalendarDays } from "react-icons/hi2";

interface CalendarViewToggleProps {
    viewMode: string;
    onChange: (
        event: React.MouseEvent<HTMLElement>,
        newMode: string | null
    ) => void;
}

const CalendarViewToggle: React.FC<CalendarViewToggleProps> = ({
    viewMode,
    onChange,
}) => {
    const intl = useIntl();
    return (
        <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={onChange}
            aria-label="View Mode Toggle"
        >
            <Tooltip
                title={intl.formatMessage({ id: "button.listView" })}
                arrow
            >
                <ToggleButton value="daily" aria-label="List View">
                    <HiOutlineBars3 />
                </ToggleButton>
            </Tooltip>
            <Tooltip
                title={intl.formatMessage({ id: "button.weeklyView" })}
                arrow
            >
                <ToggleButton value="weekly" aria-label="Calendar View">
                    <HiOutlineCalendarDays />
                </ToggleButton>
            </Tooltip>
        </ToggleButtonGroup>
    );
};

export default CalendarViewToggle;
